module.exports = __webpack_public_path__ + "images/花筑般蓝pr04-3.jpg?v=d27d5a24";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr04-3.jpg
 ** module id = 51
 ** module chunks = 1 2
 **/